/* Utils */
import {isAbsoluteUrl} from '../../common/url/urlUtils'
import {resolveWithSettleContext} from '../../common/async/promiseUtils'

/* Constants */
import {COOKIE_KEY} from '../../common/network/networkConstants'

/* Config */
import appConfig from '../../appConfig'

const getUrl = (item) => {
  const isBrowser = process.env.BROWSER && window;
  const apiUrl = !isBrowser && appConfig.voltranServerUrl
    ? appConfig.voltranServerUrl
    : appConfig.voltranUrl;

  if (item?.customApiUrl && (item?.customApiUrl?.clientUrl || item?.customApiUrl?.serverUrl)) {
    const url = isBrowser
      ? item?.customApiUrl?.clientUrl
      : item?.customApiUrl?.serverUrl || item?.customApiUrl?.clientUrl;

    return isAbsoluteUrl(url) ? url : `${apiUrl}/${url}`;
  }

  return isAbsoluteUrl(item?.clientUrl) ? item?.clientUrl : `${apiUrl}/${item?.clientUrl}`;
}

function voltranApiFactory(storefrontApiClient) {
  const voltranApi = {
    getFragments(type, params, cacheSettings) {
      const isBrowser = process.env.BROWSER && window;
      return Promise.all(
        type.reduce((promiseList, item) => {
          const url = getUrl(item);
          if (item.onlyClientSide && !isBrowser) {
            return promiseList;
          }

          promiseList.push(
            resolveWithSettleContext(
              storefrontApiClient.get(
                url,
                {
                  params: item?.paramater,
                  timeout: isBrowser ? item?.clientTimeout : item?.timeout,
                  headers: {
                    ...item?.headers,
                    ...item?.passCookies &&
                    {
                      [COOKIE_KEY]: item?.rawCookies || '',
                    },
                  },
                },
                null,
                item.cacheStatus && {
                  ...cacheSettings,
                  cacheKey: `voltran-${item.componentTypeName}-${item.id}-${item?.cacheKey || ''}`,
                  cacheStatus: item.cacheStatus,
                  expireTime: item.cacheExpireTime,
                }
              ).then(res => {
                res.data.id = item.id;
                return res;
              }).
                catch((e) => {
                  console.log(`Failed to fetch fragment ${item.componentTypeName} - ${url} ${e.message}`);
                  return e;
                })
            ))
          return promiseList
        }, [])
      )
    }
  }

  return voltranApi
}

export default voltranApiFactory
